import { Category } from "@CommonApi/categories";
import { omniAtom } from "src/utils/atoms";

export const describeVariantRestrictionModalDataAtom = omniAtom({
  prefix: "src/modals/describeVariantRestriction",
  key: "data",
  value: null as null | Category,
});
